import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import {
  dropBoolean,
  dropTipoAdmissao,
  dropIndAdmissao,
  dropRegimeTrabalho,
  dropRegimePrevidencia,
  dropRegimeJornada,
  dropFgts,
} from 'utils/drops';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import Title from '../Components/Title';

const Pessoal = ({ drops, loading, pessoal = {}, onSubmit }) => {
  const defaultValues = {
    rotina: 'Pessoal',
    id: null,
    empregador_id: null,
    estabelecimento_id: null,
    funcionario_id: null,
    matricula: '',
    categoria_trabalhador_id: null,
    dtadmissao: null,
    tpadmissao: null,
    indadmissao: null,
    indpriempr: null,
    cadini: null,
    nrrecinfprelim: '',
    tpregtrab: null,
    tpregprev: null,
    tpregjor: null,
    fgts_opcao: null,
    fgts_dtopcao: null,
    fgts_banco_id: null,
    sindical: null,
    mesbase: '',
    sefip_cat: '',
    sefip_ocor: '',
  };
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    if (pessoal) {
      const merged = Object.keys(defaultValues).reduce((acc, key) => {
        acc[key] = pessoal[key] ?? defaultValues[key];
        return acc;
      }, {});
      reset(merged);
    }
  }, [pessoal, reset]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title title="Identificação do Vínculo" disableMargin />
      </Grid>
      <Grid item xs={12} sm={6}>
        <VirtualDrop
          control={control}
          label="Empregador"
          name="empregador_id"
          options={drops?.Entidade}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <VirtualDrop
          control={control}
          label="Estabelecimento"
          name="estabelecimento_id"
          options={drops?.Entidade}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Input name="matricula" control={control} label="Matrícula" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          control={control}
          name="categoria_trabalhador_id"
          label="Categoria do Trabalhador"
          options={drops?.CategoriaTrabalhador}
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="Admissão" />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputMask
          type="date"
          name="dtadmissao"
          control={control}
          label="Data de Admissão"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          control={control}
          name="tpadmissao"
          label="Tipo de Admissão"
          options={dropTipoAdmissao}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          control={control}
          name="indadmissao"
          options={dropIndAdmissao}
          label="Indicador de Admissão"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          control={control}
          name="indpriempr"
          options={dropBoolean}
          label="Primeiro Emprego"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          name="cadini"
          control={control}
          options={dropBoolean}
          label="Cadastro Inicial"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Input
          control={control}
          name="nrrecinfprelim"
          label="Nº do Recibo de Informação Preliminar"
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="Regimes e Jornada" />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          options={dropRegimeTrabalho}
          control={control}
          name="tpregtrab"
          label="Tipo de Regime de Trabalho"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          options={dropRegimePrevidencia}
          control={control}
          name="tpregprev"
          label="Tipo de Regime de Previdência"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          options={dropRegimeJornada}
          control={control}
          name="tpregjor"
          label="Tipo de Regime de Jornada"
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="FGTS" />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          options={dropFgts}
          name="fgts_opcao"
          control={control}
          label="Opção pelo FGTS"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputMask
          type="date"
          control={control}
          name="fgts_dtopcao"
          label="Data da Opção"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <VirtualDrop
          control={control}
          name="fgts_banco_id"
          label="Banco para Depósito"
          options={drops?.EntidadeTipo?.filter(
            (f) => f?.tipo === 'INSTITUICAO FINANCEIRA'
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="Informações Sindicais" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="sindical"
          control={control}
          label="Sindicalizado"
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputMask
          name="mesbase"
          control={control}
          label="Mês Base da Contribuição Sindical"
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="Obrigações SEFIP/eSocial" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputMask control={control} label="Categoria SEFIP" name="sefip_cat" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputMask
          control={control}
          name="sefip_ocor"
          label="Ocorrência SEFIP"
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          color="primary"
          variant="contained"
          loading={loading}
          onClick={handleSubmit(onSubmit)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default Pessoal;
